/**
 * Định dạng và vị trí control msnumber
 */

export default {
  NegativeBracketsTypeOnBlur: '(,)',
  /**
   * set vị trí dấu âm prefix
   */
  NegativePositiveSignPlacementPrefix: 'p',
  /**
   * set vị trí dấu âm left
   */
  NegativePositiveSignPlacementLeft: 'l',
  /**
   * set vị trí dấu âm left
   */
  NegativePositiveSignPlacementRight: 'r',
  /**
   * set vị trí dấu âm left
   */
  NegativePositiveSignPlacementSuffix: 's',

  /**
   * khoảng cách dấu âm
   */
  NegativeSignCharacterCustomEmpty: '',

  /**
   * khoảng cách dấu âm
   */
  NegativeSignCharacterCustomSpace: ' ',

  /**
   * Dấu âm trong ngoặc
   */
  Bracket: 0,

  /**
   * Dấu âm trước
   */
  MinusSignBefore: 1,

  /**
   * Dấu âm trước có khoảng trắng
   */
  MinusSignBeforeSpace: 2,

  /**
   * Dấu âm sau
   */
  MinusSignAfter: 3,

  /**
   * Dấu âm sau có khoảng trắng
   */
  MinusSignAfterSpace: 4,

  /**
   * Màu mặc định
   */
  InputColorDefaul: '#313131',
};
